import React from 'react';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './StatusWarning.module.css';
import { CommonButton } from '_components';


export class StatusWarning extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Warning'} onClick={this.props.onClick} size={this.props.size} className={cls}>
                <FontAwesomeIcon icon={faExclamationTriangle} transform="shrink-2" color="#f7941d" />
            </CommonButton>
        );
    }
}

